import BenchlingConfig from 'BenchlingConfig';
import StringResolutionManager from 'models/managers/StringResolutionManager';
import {
  DedicatedLookupStructuredTableColumn,
  StructuredTable,
} from 'notebook/structured-tables/StructuredTableConstants';
import {removeQueryResolutionsFromSnapshot} from 'notebook/tables/excess/Resolver';
import {CustomResolutionQueryType} from 'notebook/tables/string-resolution/StringResolutionConstants';
import {TableColumnType, TableOpDiffMap} from 'notebook/tables/TableConstants';

export function handleRefreshLookupStructuredTable({
  entryOrTemplateId,
  structuredTable,
}: {
  entryOrTemplateId: string;
  structuredTable: StructuredTable<unknown, unknown>;
}): void {
  const columns: Array<DedicatedLookupStructuredTableColumn> = [];
  const colIndexes: Array<number> = [];
  structuredTable.columns.forEach((column, idx) => {
    if (column.columnType === TableColumnType.DEDICATED_LOOKUP) {
      columns.push(column as DedicatedLookupStructuredTableColumn);
      colIndexes.push(idx);
    }
  });

  handleRefreshLookupColumns({
    entryOrTemplateId,
    tableProvenanceUuid: structuredTable.provenanceUuid,
    tableOp: {[structuredTable.name]: {type: 'eval-columns', colIndexes}},
    columns,
  });
}

export function handleRefreshLookupColumns({
  entryOrTemplateId,
  tableProvenanceUuid,
  tableOp,
  columns,
}: {
  entryOrTemplateId: string;
  tableProvenanceUuid: string;
  tableOp: TableOpDiffMap;
  columns: Array<DedicatedLookupStructuredTableColumn>;
}): void {
  const lookupConfigIds = columns.map((column) => column.lookupConfig.id);
  // Clear potentially stale string resolution query cache if rendering from note runtime snapshots
  if (BenchlingConfig.ELN_ENABLE_RUNTIME_SNAPSHOT_RENDER) {
    StringResolutionManager.clearStringResolutionReduxCacheByTypeAndId(
      CustomResolutionQueryType.LOOKUP_COLUMN,
      lookupConfigIds
    );
  }

  // Delete potentially stale lookup column queryResolutions from snapshot if snapshot eval is enabled
  if (BenchlingConfig.ELN_ENABLE_RUNTIME_SNAPSHOT_EVAL) {
    removeQueryResolutionsFromSnapshot(entryOrTemplateId, tableProvenanceUuid, tableOp, lookupConfigIds);
  }
}
